var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  border-top: 2px solid ', ';\n  border-bottom: 1px solid grey;\n  padding: 10px 15px;\n\n  span {\n    padding: 10px;\n    cursor: pointer;\n    margin: 5px;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  border-top: 2px solid ', ';\n  border-bottom: 1px solid grey;\n  padding: 10px 15px;\n\n  span {\n    padding: 10px;\n    cursor: pointer;\n    margin: 5px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-right: 5px;\n'], ['\n  margin-right: 5px;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  padding: 5px;\n'], ['\n  cursor: pointer;\n  padding: 5px;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  display: ', ';\n  top: 35px;\n  list-style: none;\n  background-color: white;\n  border: 1px solid ', ';\n  padding-inline-start: 0;\n'], ['\n  position: absolute;\n  display: ', ';\n  top: 35px;\n  list-style: none;\n  background-color: white;\n  border: 1px solid ', ';\n  padding-inline-start: 0;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import styled from 'styled-components';
import Theme from '../../Theme';

var BadgeItem = function BadgeItem(_ref) {
  var action = _ref.action,
      label = _ref.label;
  return React.createElement(
    Badge,
    { color: 'primary', pill: true, onClick: action },
    React.createElement(CloseIcon, null),
    label
  );
};

var BadgeGroup = styled.div(_templateObject, Theme.colors.lightBlue);

var CloseIcon = styled.i.attrs(function (props) {
  return {
    className: 'fa fa-close'
  };
})(_templateObject2);

var AddIcon = styled.i.attrs(function (props) {
  return {
    className: 'fa fa-plus'
  };
})(_templateObject2);

var OptionBox = styled.li(_templateObject3);

var Select = styled.ul(_templateObject4, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'block' : 'none';
}, Theme.colors.blueGrey);

var Option = function Option(_ref3) {
  var action = _ref3.action,
      label = _ref3.label,
      key = _ref3.key;
  return React.createElement(
    OptionBox,
    { onClick: function onClick() {
        return action(key);
      } },
    label
  );
};

var BadgeSelectBox = styled.div(_templateObject5);

var BadgeSelect = function BadgeSelect(_ref4) {
  var onSelect = _ref4.onSelect,
      options = _ref4.options,
      title = _ref4.title;

  var _useState = useState(false),
      visible = _useState[0],
      setVisibility = _useState[1];

  var _useState2 = useState(''),
      text = _useState2[0],
      setText = _useState2[1];

  var actionHandler = function actionHandler(key) {
    onSelect(key);
    setText('');
    setVisibility(false);
  };

  return React.createElement(
    BadgeSelectBox,
    null,
    React.createElement(
      'div',
      { onClick: function onClick() {
          return setVisibility(true);
        } },
      React.createElement(AddIcon, null),
      React.createElement('input', { type: 'text', placeholder: 'Add ' + title, value: text, onChange: function onChange(e) {
          return setText(e.target.value);
        } })
    ),
    React.createElement(
      Select,
      { visible: visible && text },
      options.filter(function (_ref5) {
        var key = _ref5.key;
        return key.toLowerCase().includes(text.toLowerCase());
      }).map(function (_ref6) {
        var key = _ref6.key,
            label = _ref6.label;
        return React.createElement(Option, { action: function action() {
            return actionHandler(key);
          }, label: label, key: key });
      })
    )
  );
};

var reducer = function reducer(_ref7, _ref8) {
  var selected = _ref7.selected;
  var type = _ref8.type,
      data = _ref8.data;

  switch (type) {
    case 'remove':
      var idx = selected.findIndex(function (key) {
        return key === data;
      });
      return {
        selected: [].concat(selected.slice(0, idx), selected.slice(idx + 1, selected.length))
      };
    case 'add':
      return {
        selected: [].concat(selected, [data])
      };
  }
};

var BadgeGroupDef = function BadgeGroupDef(_ref9) {
  var options = _ref9.options,
      _ref9$selecteds = _ref9.selecteds,
      selecteds = _ref9$selecteds === undefined ? [] : _ref9$selecteds,
      title = _ref9.title;

  var _useReducer = useReducer(reducer, { selected: selecteds }),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return React.createElement(
    BadgeGroup,
    null,
    state.selected.map(function (key) {
      return React.createElement(BadgeItem, { color: 'primary', action: function action() {
          return dispatch({ type: 'remove', data: key });
        }, label: options.find(function (item) {
          return item.key === key;
        }).label });
    }),
    React.createElement(BadgeSelect, { title: title, options: options, onSelect: function onSelect(data) {
        return dispatch({ type: 'add', data: data });
      } })
  );
};

BadgeGroupDef.displayName = 'BadgeGroup';
BadgeGroupDef.propTypes = process.env.NODE_ENV !== "production" ? {
  options: PropTypes.arrayOf(PropTypes.objectOf({
    key: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  selecteds: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired
} : {};

export default BadgeGroupDef;